module.exports = __webpack_public_path__ + "static/media/Inter-Medium.5ce3e4db.woff";